import { useState } from "react";
import { cn } from "@/lib/utils";
import { copyText } from "@/lib/engine";

/**
 * Claude Code 指令塊：顯示指令 + 一鍵複製。
 *
 * 守 `mcp-local-ui-principle`：網頁只組指令草稿給人複製，
 * 不在瀏覽器裡直接執行任何 AI 呼叫。
 */
export function CommandBlock({
  command,
  label = "複製指令給 Claude Code",
  hint,
  className,
}: {
  command: string;
  label?: string;
  hint?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    const ok = await copyText(command);
    setCopied(ok);
    if (ok) setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className={cn("min-w-0", className)}>
      <div className="flex items-center justify-between gap-3 mb-2 flex-wrap">
        <span className="text-[11px] font-bold tracking-[0.15em] text-brand-gold uppercase">
          Claude Code
        </span>
        <button
          onClick={handleCopy}
          className={cn(
            "px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap",
            copied
              ? "bg-brand-green text-white"
              : "bg-brand-dark text-brand-cream hover:bg-brand-gold",
          )}
        >
          {copied ? "已複製，去終端機貼上" : label}
        </button>
      </div>

      <pre
        className="text-[12px] leading-relaxed bg-brand-dark text-brand-cream/90 rounded-md p-4 font-mono min-w-0 max-w-full overflow-x-auto"
        style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
      >
        {command}
      </pre>

      {hint && (
        <p className="text-xs text-brand-dark/50 mt-2 leading-relaxed">{hint}</p>
      )}
    </div>
  );
}
